import {
  Button as MuiButton,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField
} from '@material-ui/core'
import React from 'react'

import { fetchAtHomeIssues, resolveAtHomeIssue } from 'api/atHome'
import Button from 'app/components/generic/Button'
import constants from 'app/constants'
import { eventAlert } from 'app/helpers'

import { fmtDateTime, titleCase } from './format'
import AtHomeCrudPage from './shared/AtHomeCrudPage'

const COLUMNS = [
  { name: 'typeLabel', label: 'Type' },
  { name: 'description', label: 'Issue', options: { filter: false } },
  { name: 'session', label: 'Session', options: { filter: false } },
  { name: 'raisedByName', label: 'Raised by' },
  { name: 'when', label: 'Raised', options: { filter: false } },
  { name: 'statusLabel', label: 'Status' },
  { name: 'resolution_notes', label: 'Resolution', options: { filter: false } }
]

const row = (i) => ({
  ...i,
  typeLabel: i.type === 'safety' ? '⚠️ Safety' : 'Operational',
  session: i.bookingSummary
    ? `${i.bookingSummary.category} · ${i.bookingSummary.child} · ${i.bookingSummary.date} ${i.bookingSummary.startTime} · ${i.bookingSummary.apartment}`
    : '—',
  raisedByName: i.raisedBy?.name || '',
  when: fmtDateTime(i.created),
  statusLabel: titleCase(i.status)
})

/** Issues teachers raised from their At-Home sessions. Safety first. */
const AtHomeIssues = () => {
  const [resolving, setResolving] = React.useState(null)
  const [notes, setNotes] = React.useState('')
  const [refreshKey, setRefreshKey] = React.useState(0)

  const fetchList = React.useCallback(async () => {
    const all = (await fetchAtHomeIssues('all')).map(row)
    // open first, safety before operational, newest first within
    return all.sort((a, b) =>
      a.status !== b.status
        ? a.status === 'open'
          ? -1
          : 1
        : a.type !== b.type
        ? a.type === 'safety'
          ? -1
          : 1
        : b.created.localeCompare(a.created)
    )
  }, [])

  const resolve = async () => {
    try {
      await resolveAtHomeIssue(resolving.uuid, notes)
      eventAlert('Issue resolved', constants.SUCCESS)
      setResolving(null)
      setNotes('')
      setRefreshKey((k) => k + 1)
    } catch (error) {
      // toast from request.js
    }
  }

  return (
    <>
      <AtHomeCrudPage
        subtitle="Issues raised by teachers, safety issues first."
        entityLabel="Issue"
        fetchList={fetchList}
        columns={COLUMNS}
        refreshKey={refreshKey}
        rowActions={(r) =>
          r.status === 'open' ? (
            <Button size="small" onClick={() => setResolving(r)}>
              Resolve
            </Button>
          ) : null
        }
      />
      <Dialog
        open={Boolean(resolving)}
        onClose={() => setResolving(null)}
        fullWidth
        maxWidth="xs"
      >
        <DialogTitle>Resolve issue</DialogTitle>
        <DialogContent>
          <TextField
            label="What was done"
            value={notes}
            onChange={(e) => setNotes(e.target.value)}
            fullWidth
            multiline
            minRows={3}
            autoFocus
          />
        </DialogContent>
        <DialogActions>
          <MuiButton onClick={() => setResolving(null)}>Back</MuiButton>
          <MuiButton onClick={resolve} color="primary" variant="contained">
            Mark resolved
          </MuiButton>
        </DialogActions>
      </Dialog>
    </>
  )
}

export default AtHomeIssues
